import React from 'react';
import {
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Area,
	AreaChart
} from 'recharts';

export default function CountChart({ data, color, colors, possibleColors }) {
	return (
		<AreaChart
			className="areaChartRechart"
			width={600}
			height={300}
			data={data}
			margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
		>
			<XAxis dataKey="name" />
			<YAxis />
			<CartesianGrid strokeDasharray="3 3" />
			<Tooltip />
			{color ? (
				<Area type="monotone" dataKey="count" stroke="black" fill={color} />
			) : null}
			{colors ?
				possibleColors.map((currentColor, index) => (
					<Area
						key={`colorCodeCountOverTime-${currentColor}-${index}`}
						type="monotone"
						dataKey={currentColor}
						stroke="black"
						fill={colors[index]}
					/>
				)) :
				null}
		</AreaChart>
	);
}
